module.exports = __webpack_public_path__ + "img/ic_insta.4ab43793.png";